// Really simple application of a Mui Snackbar that can be reused.
// Simply pass in a notification object { key: string, message: string } and handle the 'onClose' event.
// The snackbar will close automatically after a few seconds.

import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';

const BasicSnackbar = ({ notification, onClose }) => {
    return (
        <Snackbar
            key={notification && notification.key}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            open={Boolean(notification)}
            autoHideDuration={3000}
            message={notification && notification.message}
            onClose={onClose}
            slotProps={{
                content: {
                    'aria-describedby': 'message-id'
                }
            }} />
    );
};

BasicSnackbar.propTypes = {
    notification: PropTypes.shape({
        key: PropTypes.any,
        message: PropTypes.any
    }),
    onClose: PropTypes.func
};

export default BasicSnackbar;
